import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';

import { LOCAL_STORAGE } from '../../v2-config/constants/local-storage.constant';
import { GetLocalStorageValue } from '../../_config/utils/get-local-storage-value.util';

import Loading from '../../v2-components/Loading';
import ProductReport from './components/ProductReport';

import { Language } from './constants/language.constant';
import { Service } from './service';

import './style.scss'

export default function ReportPage() {
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const user = GetLocalStorageValue(LOCAL_STORAGE.USER);
	const pharmacy = user.pharmacy;

	useEffect(() => {
		const handleGetData = () => {
			new Service().getReports(pharmacy).then((response) => {
				setData(response);
				setIsLoading(false);
			});
		};
		handleGetData();
	}, [pharmacy]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className='report-container'>
			{JSON.stringify(Language[Enviroment])}
			<Row justify="center">
				<Col span={8}>
					<h2 style={{ color: 'grey' }}>{Language[Enviroment.LANGUAGE]?.title} {pharmacy && pharmacy}</h2>
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<ProductReport data={data} />
				</Col>
			</Row>
		</div>
	);
}
